import {
  getCluster,
  getClusters,
  postClusters,
  updateCluster,
  deleteCluster,
} from '@/api';

const localState = {
  clusters: [],
};

const actions = {
  async create({ commit }, { nodes, edges, projectId, clusterName }) {
    const res = await postClusters({ nodes, edges, projectId, clusterName });
    const { code, cluster, msg } = res.data;
    if (code !== 0) throw new Error(msg);
    commit('addCluster', { cluster });
  },
  async get(context, { clusterId }) {
    const res = await getCluster({ clusterId });
    const { code, msg, clusterGraphData } = res.data;
    if (code !== 0) throw new Error(msg);
    return clusterGraphData;
  },
  async index({ commit }, { projectId }) {
    const res = await getClusters({ projectId });
    const { code, msg, clusters } = res.data;
    if (code !== 0) throw new Error(msg);
    commit('setClusters', { clusters });
  },
  async update({ commit }, clusterForm) {
    const res = await updateCluster({ ...clusterForm });
    const { code, msg, cluster } = res.data;
    if (code !== 0) throw new Error(msg);
    commit('updateCluster', { cluster });
  },
  async delete({ commit }, { clusterId }) {
    const res = await deleteCluster({ clusterId });
    const { code, msg } = res.data;
    if (code !== 0) throw new Error(msg);
    commit('deleteCluster', { clusterId });
  },
};

const mutations = {
  addCluster(state, { cluster }) {
    state.clusters.push(cluster);
  },
  setClusters(state, { clusters }) {
    state.clusters = clusters;
  },
  updateCluster(state, { cluster }) {
    const index = state.clusters.findIndex(c => c.id === cluster.id);
    if (index >= 0) {
      state.clusters.splice(index, 1, cluster);
    } else {
      state.clusters.push(cluster);
    }
  },
  deleteCluster(state, { clusterId }) {
    const index = state.clusters.findIndex(c => c.id === clusterId);
    if (index >= 0) {
      state.clusters.splice(index, 1);
    }
  },
};

export default {
  actions,
  mutations,
  state: localState,
  namespaced: true,
};

